import axios from './axios';
import { getToken } from './authService';
import { API_URL } from '../config/env';

export async function getCurrentUser() {
  const token = getToken();
  if (!token) throw new Error('No token');
  const res = await axios.get(`${API_URL}/api/auth/me`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}

export async function updateCurrentUser(data) {
  const token = getToken();
  if (!token) throw new Error('No token');
  const res = await axios.put(`${API_URL}/api/users/me`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}
